import { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { roundDecimal, formatCalendarDate } from "../../../../utils/helperFunctions";
import CommonLoadingIndicator from "./CommonLoadingIndicator";

type TableProps = {
  data: Array<Object>;
};

const dateSortComparator = (_v1: string, _v2: string, params1: any, params2: any) => {
  const raw1 = params1.api.getRow(params1.id)?.rawDateTime || "";
  const raw2 = params2.api.getRow(params2.id)?.rawDateTime || "";
  return raw1.localeCompare(raw2);
};

const columns = [
  { field: "date", headerName: "Date (UTC)", width: 200, sortComparator: dateSortComparator },
  { field: "protein", headerName: "Protein", width: 200 },
  {
    field: "carbohydrates",
    headerName: "Carbohydrates",
    width: 200,
  },
  { field: "fats", headerName: "Fats", width: 200 },
  { field: "calories", headerName: "Calories", width: 200 },
];

export function transformDataToRows(data: Array<Object>) {
  return data.map((value: any) => {
    return {
      id: value.$id,
      date: formatCalendarDate(value.consumedDate),
      rawDateTime: value.consumedDate || "",
      protein: roundDecimal((value.proteinG || "0") + "g"),
      carbohydrates: roundDecimal(
        (value.carbohydrateByDifferenceG || "0") + "g"
      ),
      fats: roundDecimal((value.totalLipidFatG || "0") + "g"),
      calories: roundDecimal(
        value.energyKcal || (value.energyKj > 0 ? value.energyKj / 4.184 : "0")
      ),
    };
  });
}

function MacronutrientTable({ data }: TableProps) {
  const [tableRows, setTableRows] = useState<Array<Object>>();
  const [dataLoaded] = useState<Boolean>(true);

  useEffect(() => {
    if (!data) return;
    try {
      const transformedRows = transformDataToRows(data);
      setTableRows(transformedRows);
    } catch (error) {
      console.log(error);
    }
  }, [data]);

  if (tableRows && dataLoaded) {
    return (
      <DataGrid
        data-testid="macronutrient-table"
        rows={tableRows}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 10,
            },
          },
        }}
        checkboxSelection
        disableRowSelectionOnClick
        pageSizeOptions={[5, 10, 20]}
      />
    );
  } else {
    return <CommonLoadingIndicator />;
  }
}

export default MacronutrientTable;
